export default {
  all: [],
  dashboardSections: [],
  widgetsWithoutSection: [],
  loading: false
}
